<template>
  <div class="headerDiv fixWhite">
    <!-- :class="scroll ? 'headerDiv fixWhite fixHeader' : 'headerDiv'" -->
    <router-link to="/" style="margin-left: 5%">
      <div class="logo">
        <img :src="logoSrc" />
      </div>
    </router-link>

    <div class="right">
      <el-menu
        ref="navMenu"
        :default-active="$route.path"
        mode="horizontal"
        :router="router"
        popper-append-to-body
      >
        <el-menu-item index="/">{{ $t("route.首页") }}</el-menu-item>
        <el-submenu index="/product" popper-class="subMenuClass">
          <template slot="title"
            ><router-link to="/product" style="color: #333">{{
              $t("route.产品")
            }}</router-link></template
          >
          <!-- /ezzloc -->
          <el-menu-item
            v-for="(item, index) in tabList"
            :key="index"
            :index="'/product/' + item.type"
          >
            <template slot="title">
              <div class="menu2">
                <img :src="item.img" alt="" style="border-radius: 10px" />
                <div>
                  <div class="menuTitle">{{ item.name }}</div>
                  <!-- <div class="menuText">{{ item.name }}</div> -->
                </div>
              </div>
            </template>
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="/sulutions">{{
          $t("route.解决方案")
        }}</el-menu-item>
        <el-submenu index="/aboutus" popper-class="subMenuClass">
          <template slot="title"
            ><router-link to="/aboutus" style="color: #333">{{
              $t("route.关于我们")
            }}</router-link></template
          >
          <el-menu-item index="/aboutus">
            <template slot="title">
              <div class="menu2">
                <svg-icon icon-class="aboutus" ></svg-icon>
                <div>
                  <div class="menuTitle">{{ $t("route.公司简介") }}</div>
                </div>
              </div>
            </template>
          </el-menu-item>
          <el-menu-item index="/news">
            <template slot="title">
              <div class="menu2">
                <svg-icon icon-class="news"></svg-icon>
                <div>
                  <div class="menuTitle">{{ $t("route.新闻") }}</div>
                </div>
              </div>
            </template>
          </el-menu-item>
        </el-submenu>
        <!-- <el-submenu index="/news" popper-class="subMenuClass">
          <template slot="title"
            ><router-link to="/news" style="color: #333">{{
              $t("route.服务与支持")
            }}</router-link></template
          >
          <el-menu-item index="/news">
            <template slot="title">
              <div class="menu2">
                <img :src="weizhiIcon" alt="" style="border-radius: 10px" />
                <div>
                  <div class="menuTitle">{{ $t("route.FAQ") }}</div>
                </div>
              </div>
            </template>
          </el-menu-item>
          <el-menu-item index="/service/2">
            <template slot="title">
              <div class="menu2">
                <img :src="chelianIcon" alt="" />
                <div>
                  <div class="menuTitle">{{ $t("route.下载") }}</div>
                </div>
              </div>
            </template>
          </el-menu-item>
        </el-submenu> -->
      </el-menu>
      <!-- <img src="../assets/img/tel.png" /> -->
      <!-- <a href="https://www.daovay.com/" target="_blank" class="toEn">En</a> -->
    </div>
    <div v-if="showMenu" class="showMenu">
      <el-menu
        ref="navMenu"
        :default-active="$route.path"
        mode="horizontal"
        :router="router"
        popper-append-to-body
      >
        <el-menu-item index="/">{{ $t("route.首页") }}</el-menu-item>
        <el-submenu index="/product" popper-class="subMenuClass">
          <template slot="title"
            ><router-link to="/product" style="color: #333">{{
              $t("route.产品")
            }}</router-link></template
          >
          <el-menu-item
            v-for="(item, index) in tabList"
            :key="index"
            :index="'/product/' + item.type"
          >
            <template slot="title">
              <div class="menu2">
                <img :src="item.img" alt="" style="border-radius: 10px" />
                <div>
                  <div class="menuTitle">{{ item.name }}</div>
                  <!-- <div class="menuText">{{ item.name }}</div> -->
                </div>
              </div>
            </template>
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="/sulutions">{{
          $t("route.解决方案")
        }}</el-menu-item>
        <el-submenu index="/aboutus" popper-class="subMenuClass">
          <template slot="title"
            ><router-link to="/aboutus" style="color: #333">{{
              $t("route.关于我们")
            }}</router-link></template
          >
          <el-menu-item index="/aboutus">
            <template slot="title">
              <div class="menu2">
                <svg-icon icon-class="aboutus" ></svg-icon>
                <div>
                  <div class="menuTitle">{{ $t("route.公司简介") }}</div>
                </div>
              </div>
            </template>
          </el-menu-item>
          <el-menu-item index="/news">
            <template slot="title">
              <div class="menu2">
                <svg-icon icon-class="news"></svg-icon>
                <div>
                  <div class="menuTitle">{{ $t("route.新闻") }}</div>
                </div>
              </div>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <svg-icon icon-class="menu" class="leaf" @click="showMenuFun(showMenu)" />
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      showMenu: false,
      router: true,
      language: "en",
      scroll: false,
      swiperTab: 0,
      logoSrc: require("../assets/img/logo_Y.png"),
      tabList: [
      {
          name: "Hardwired Tracker",
          type: 1,
          img: require("../assets/img/product/navList/HardwiredTracker.png"),
        },
        {
          name: "OBD Tracker",
          type: 2,
          img: require("../assets/img/product/navList/OBDTracker.png"),
        },
        {
          name: "Video Terminal",
          type: 3,
          img: require("../assets/img/product/navList/VideoTerminal.png"),
        },
        {
          name: "Tire Pressure Monitoring",
          type: 4,
          img: require("../assets/img/product/navList/TirePressureMonitoring.png"),
        },
        {
          name: "Portable Tracker",
          type: 5,
          img: require("../assets/img/product/navList/PortableTracker.png"),
        },
        {
          name: "Sensor Accessories",
          type: 6,
          img: require("../assets/img/product/navList/SensorAccessories.png"),
        },
      ],
    };
  },
  watch: {
    $route(route) {
      this.showMenu = false;
    },
  },
  created() {
    console.log(this.$t("route.dash"));
    //this.language = getLocale();
  },
  mounted() {
    window.addEventListener("scroll", this.fixedActiveBtn);
  },
  methods: {
    fixedActiveBtn() {
      const that = this;
      var topScroll = document.documentElement.scrollTop; //滚动的距离,距离顶部的距离
      if (topScroll > 0) {
        //document.documentElement.clientHeight - 120
        //当滚动距离大于页面高度时执行下面的东西
        that.scroll = true;
      } else {
        //当滚动距离小于页面高度的时候执行下面的内容，也就是让导航栏恢复原状
        that.scroll = false;
      }
    },
    showMenuFun(show) {
      if (!show) {
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
    },
  },
};
</script>
<style lang="scss" >
.headerDiv {
  width: 100%;
  height: 100px;
  // padding: 20px 2%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background-color: #2e3652;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  transition: all linear 0.5s;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  .right {
    display: flex;
    // justify-content: flex-end;
    align-items: center;
    margin-right: 10%;
    img {
      height: 30px;
      margin-right: 20%;
    }
    .toEn {
      display: block;
      padding: 4px 15px;
      border: 1px solid #00bebe;
      color: #00bebe;
      font-size: 14px;
      background-color: rgba(0, 190, 190, 0.1);
    }
  }
  .logo {
    display: flex;
    align-items: center;
    float: left;
    margin-left: 50px;

    img {
      width: auto;
      height: 70px;
      line-height: 60px;
    }

    img:nth-child(1) {
      display: inline-block;
    }

    img:nth-child(2) {
      display: none;
    }
  }
  .leaf {
    // position: absolute;
    // right: 5%;
    display: none;
    cursor: pointer;
  }
  .menuMobile {
    display: none;
  }
  .el-menu {
    float: left;
    display: flex;
    justify-content: space-between;
    background-color: transparent;
    align-items: center;
    margin-top: 0px;
    margin-right: 7%;
    border-bottom: none !important;

    li {
      font-size: 2.1vh;
      height: 100px;
      line-height: 100px;
      padding: 0;
      text-align: center;
      position: relative;
      width: 100px;
      color: #333 !important;
      margin: 0 20px;
      &::before {
        display: block;
        content: "";
        position: absolute;
        left: 40%;
        width: 20%;
        opacity: 0;
        height: 2px;
        bottom: 0;
        z-index: 1;
        transition: 0.4s;
        background-color: #00bebe;
      }

      &:hover,
      &:focus,
      &.is-active {
        border-bottom: none !important;
        color: #00bebe !important;
        .el-submenu__title {
          border-bottom: none !important;
          color: #00bebe !important;
          &::before {
            opacity: 1;
            left: 0;
            width: 100%;
          }
        }
        a {
          color: #00bebe !important;
        }
        &::before {
          opacity: 1;
          left: 0;
          width: 100%;
        }
      }
      .el-submenu__title {
        color: #333 !important;
        vertical-align: baseline;
        width: 100px;
        height: 100px;
        line-height: 100px;
        padding: 0;
        text-align: center;
        font-size: 2.1vh;
        border: none;
        i {
          display: none;
        }
        a {
          color: #333 !important;
        }
        &::before {
          display: block;
          content: "";
          position: absolute;
          left: 40%;
          width: 20%;
          opacity: 0;
          height: 2px;
          bottom: 0px;
          transition: 0.4s;
          background-color: #00bebe;
        }
      }
    }
  }
  .el-dropdown {
    margin-right: 30px;
  }

  .blackdropdown {
    color: #000;
  }

  .whitedropdown {
    color: #fff;
  }
}
.subMenuClass {
  width: 100%;
  .el-menu {
    width: 100%;
    background-color: #fff;
    color: #000 !important;
    border-radius: 7px;
    position: relative;
    display: flex;
    justify-content: space-around;
    box-shadow: none;
    // margin-top: 13px;
    // flex-wrap: wrap;
    padding: 30px !important;
    li {
      // width: 32%;
      margin-right: 1% !important;
      height: fit-content !important;
      line-height: fit-content;
      color: #000 !important;
      font-size: 17px;
      text-align: center;
      .menu2 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        // letter-spacing: 1px;
        align-items: center;
        img, .svg-icon{
          height: 8vh;
          // font-size:3.8vh;
          margin-bottom: 20px;
          color:#00bebe;
        }
        .menuTitle {
          line-height: 20px;
          font-size: 1.6vh;
          font-weight: bold;
          color: #273043;
        }
        .menuText {
          margin-top: 4px;
          line-height: 30px;
          font-size: 1.4vh;
          color: rgba(0, 0, 0, 0.7);
        }
      }
    }
  }
}
.fixWhite {
  position: fixed;
  background-color: #ffffff;
  box-shadow: 0 0 10px 3px #ededed;

  // box-shadow: 0 0 10px 4px #dcdbdb;
  .el-menu--horizontal .el-menu--horizontal > .el-submenu {
  }

  .el-menu--horizontal > li {
  }
}

.fixDark {
  position: fixed;
  background-color: rgba(99, 99, 99, 0.623);
  box-shadow: none;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #00c977;
}
@media only screen and (max-width: 767px) {
  .headerDiv {
    background-color: #fff;
    height: 50px;
    .right {
      display: none;
    }
    .leaf {
      display: block;
      font-size: 30px;
      top: 3px;
      color: #00bebe;
      margin-right: 5%;
    }
    .logo {
      width: auto;
      margin-left: 10px;
      img {
        height: 40px;
        line-height: 40px;
      }
    }
    .el-menu {
      display: none;
    }
    .showMenu {
      position: absolute;
      top: 55px;
      width: 100%;
      border-top: 1px solid #eee;
      .el-menu {
        width: 100%;
        display: block;
        float: none;
        background-color: rgba(255, 255, 255, 1.438);
        li {
          width: 100%;
          float: none;
          height: 50px;
          line-height: 50px;
          font-size: 1.6vh;
          text-align: left;
          margin: 0;
          padding: 0px 20px;
          box-sizing: border-box;
          .el-submenu__title {
            width: 100%;
            float: none;
            height: 50px;
            line-height: 50px;
            font-size: 1.6vh;
            text-align: left;
            border: none;
            display: flex;
            align-items: center;
            justify-content: space-between;
            i {
              display: block;
            }
            a {
              color: #333 !important;
            }
            &::before {
              display: none;
              content: " ";
              position: absolute;
              left: 40%;
              width: 100%;
              opacity: 0;
              height: 2px;
              bottom: 0px;
              transition: 0.4s;
              background-color: #00bebe;
            }
          }
        }
      }
      .el-menu--horizontal > .el-menu-item::before {
        bottom: 0%;
      }
      .el-menu--horizontal > .el-submenu .el-submenu__title::before {
        bottom: 0%;
      }
    }
  }
  .subMenuClass .el-menu {
    flex-wrap: wrap;
    padding: 10px !important;
    li {
      width: 45%;
      padding:10px 0 !important;
      box-sizing: border-box;
      img {
        margin-bottom: 10px;
      }
      .menu2 {
        .menuText {
          line-height: 20px;
        }
      }
    }
  }
}
</style>